import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import homeIcon from '../assets/home-icon.png';
import backIcon from '../assets/back-icon.png';
import backIconInactive from '../assets/back-icon-inactive.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/screensaver';
  const canGoBack = location.pathname.split('/').length > 2;

  return (
    <div className={`header ${isHome ? 'home' : ''}`}>
      <div className="home-button clickable" onClick={() => navigate('/')}>
        <img className="back-icon" src={homeIcon} alt="" />
      </div>
      <div className={`back-button ${canGoBack ? 'clickable' : ''}`} onClick={() => {
        if (canGoBack) navigate(-1);
      }}>
        <img className="map-icon" src={canGoBack ? backIcon : backIconInactive} alt="" />
      </div>
    </div>
  );
};

export default Header;
